import React from 'react';
import { Users, Lightbulb, HeadphonesIcon } from 'lucide-react';
import professionalTeam from '../../assets/idlbay-Professional-team-2025.jpg';

const WhyChooseSection = ({ colors, visibleSections }) => {
  return (
    <section 
      className="py-4 performance-optimized" 
      style={{ backgroundColor: colors.bodyBlack, color: colors.white }}
      data-section="choose"
    >
      <div className="container">
        <div className={`text-center mb-5 smooth-reveal ${visibleSections.choose ? 'revealed' : ''}`}>
          <h1 className="h1 mb-3 fw-bold" style={{ color: colors.white }}>Why Choose IDLBAY?</h1>
          <h2 className="lead" style={{ color: colors.whiteTransparent }}>
            We prioritize your needs and goals, ensuring every solution is tailored to your unique vision.
          </h2>
        </div>
        
        <div className="row g-4 mb-5 d-none d-md-flex">
          <div className="col-lg-4 col-md-6">
            <div className={`text-center p-3 card-hover-effect smooth-reveal delay-100 ${visibleSections.choose ? 'revealed' : ''}`}>
              <div 
                className="rounded-circle d-inline-flex align-items-center justify-content-center mb-3" 
                style={{
                  width: '70px', 
                  height: '70px',
                  backgroundColor: `var(--color-primary)`
                }}
              >
                <Users size={28} style={{ color: colors.white }} />
              </div>
              <h4 className="mb-3 h5" style={{ color: `var(--color-primary)` }}>Client-Centric Approach</h4>
              <h6 className="cardtextdesktop" style={{ color: colors.whiteTransparent }}>
                We prioritize your needs and goals, ensuring every solution is tailored to your unique vision 
                and business requirements.
              </h6>
            </div>
          </div>
          
          <div className="col-lg-4 col-md-6">
            <div className={`text-center p-3 card-hover-effect smooth-reveal delay-200 ${visibleSections.choose ? 'revealed' : ''}`}>
              <div 
                className="rounded-circle d-inline-flex align-items-center justify-content-center mb-3" 
                style={{
                  width: '70px', 
                  height: '70px',
                  backgroundColor: `var(--color-primary)`
                }}
              >
                <Lightbulb size={28} style={{ color: colors.white }} />
              </div>
              <h4 className="mb-3 h5" style={{ color: `var(--color-primary)` }}>Innovative Solutions</h4>
              <h6 className="cardtextdesktop" style={{ color: colors.whiteTransparent }}>
                Leveraging the latest technologies and creative thinking to deliver groundbreaking results 
                that set you apart from the competition.
              </h6>
            </div>
          </div>
          
          <div className="col-lg-4 col-md-12">
            <div className={`text-center p-3 card-hover-effect smooth-reveal delay-300 ${visibleSections.choose ? 'revealed' : ''}`}>
              <div 
                className="rounded-circle d-inline-flex align-items-center justify-content-center mb-3" 
                style={{
                  width: '70px', 
                  height: '70px',
                  backgroundColor: `var(--color-primary)`
                }}
              >
                <HeadphonesIcon size={28} style={{ color: colors.white }} />
              </div>
              <h4 className="mb-3 h5" style={{ color: `var(--color-primary)`}}>Dedicated Support</h4>
              <h6 className="cardtextdesktop" style={{ color: colors.whiteTransparent }}>
                Our team provides continuous support, ensuring your digital assets perform optimally 
                and your business operations run smoothly.
              </h6>
            </div>
          </div>
        </div>

        <div className="cards-mobile-two-per-row d-md-none mb-5">
          <div className={`text-center card-mobile-compact card-hover-effect smooth-reveal delay-100 ${visibleSections.choose ? 'revealed' : ''}`}>
            <div 
              className="rounded-circle d-inline-flex align-items-center justify-content-center card-icon-mobile" 
              style={{
                width: '60px', 
                height: '60px',
                backgroundColor: `var(--color-primary)`,
                marginBottom: '0.75rem'
              }}
            >
              <Users size={24} style={{ color: colors.white }} />
            </div>
            <h4 className="card-title-mobile" style={{ color: `var(--color-primary)`, fontSize: '1rem', marginBottom: '0.75rem' }}>Client-Centric</h4>
            <h5 className="card-text-mobile" style={{ color: colors.whiteTransparent, fontSize: '0.85rem', lineHeight: '1.4' }}>
              We prioritize your needs and goals, ensuring tailored solutions.
            </h5>
          </div>
          
          <div className={`text-center card-mobile-compact card-hover-effect smooth-reveal delay-200 ${visibleSections.choose ? 'revealed' : ''}`}>
            <div 
              className="rounded-circle d-inline-flex align-items-center justify-content-center card-icon-mobile" 
              style={{
                width: '60px', 
                height: '60px',
                backgroundColor: `var(--color-primary)`,
                marginBottom: '0.75rem'
              }}
            >
              <Lightbulb size={24} style={{ color: colors.white }} />
            </div>
            <h4 className="card-title-mobile" style={{ color: `var(--color-primary)`, fontSize: '1rem', marginBottom: '0.75rem' }}>Innovation</h4>
            <h5 className="card-text-mobile" style={{ color: colors.whiteTransparent, fontSize: '0.85rem', lineHeight: '1.4' }}>
              Latest technologies and creative thinking for groundbreaking results.
            </h5>
          </div>
          
          <div className={`text-center card-mobile-compact card-hover-effect smooth-reveal delay-300 ${visibleSections.choose ? 'revealed' : ''}`} style={{gridColumn: '1 / -1', maxWidth: '200px', margin: '0 auto'}}>
            <div 
              className="rounded-circle d-inline-flex align-items-center justify-content-center card-icon-mobile" 
              style={{
                width: '60px', 
                height: '60px',
                backgroundColor: `var(--color-primary)`,
                marginBottom: '0.75rem'
              }}
            >
              <HeadphonesIcon size={24} style={{ color: colors.white }} />
            </div>
            <h4 className="card-title-mobile" style={{ color: `var(--color-primary)`, fontSize: '1rem', marginBottom: '0.75rem' }}>Support</h4>
            <h5 className="card-text-mobile" style={{ color: colors.whiteTransparent, fontSize: '0.85rem', lineHeight: '1.4' }}>
              Continuous support for optimal performance and smooth operations.
            </h5>
          </div>
        </div>
        
        <div className="row">
          <div className="col-lg-6">
          <img 
  src={professionalTeam}
  alt="IDLBAY professional technology team providing web development, mobile apps, and IT solutions"
  className="img-fluid"
  style={{
    borderTopLeftRadius: "120px",
    borderBottomRightRadius: "120px"
  }}
/>
          </div>
          <div className="col-lg-6 d-flex align-items-center">
            <div className={`ms-lg-4 mt-4 mt-lg-0 smooth-reveal delay-500 ${visibleSections.choose ? 'revealed' : ''}`}>
              <h3 className="mb-4 fw-bold" style={{ color: `var(--color-primary)` }}>Our Commitment to Excellence</h3>
              <h5 className="mb-4" style={{ color: colors.whiteTransparent }}>
                At IDLBAY, we are committed to a culture of excellence, respect, and shared success. 
                We foster innovation through continuous learning and development opportunities.
              </h5>
              <ul className="list-unstyled" style={{ color: colors.whiteTransparent }}>
                <li className="mb-2">✓ Collaborative and Inclusive Culture</li>
                <li className="mb-2">✓ Continuous Learning & Development</li>
                <li className="mb-2">✓ Flexible Work-Life Balance</li>
                <li className="mb-2">✓ Competitive Compensation & Benefits</li>
                <li className="mb-2">✓ Engaging and Impactful Projects</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseSection;